export default __webpack_public_path__ + "static/media/valley1.0093aa28.png";